// Video Session Tab Names
export const Completed = "Completed";
export const Today = "Today";
export const Upcoming = "Upcoming";
export const workout = "workout"